module.exports = __webpack_public_path__ + "img/1.6ba46055.jpg";